

import TopBarResponsive from './topbar-responsive';

import NotificationsMenu from "./notifications-menu";
import NotificationsMenuResponsive from "./notifications-menu-responsive";

import UserDropdown from "./user-dropdown"

import NotificationsPopup from './notifications-popup';
import {authUserId} from "../lib/helpers/user";
import SearchBar from "./search/search-bar";
import React from "react";

import UserNotifications from '../lib/users/user-notifications';

class TopBar extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            count : {}
        }
    }

    componentDidMount() {
        UserNotifications.addListener(count => {
            this.setState({count : count});
        });
    }


    render() {
        const notificationParams = {
            setShowNotifications : '',
            setShowMessages : '',
            notificationCount : this.state.count
        };
        return (
            <div className="topbar">

                <TopBarResponsive
                    img={'img'}
                    onClick={'dropdownClickHandler'}
                    notificationParams={notificationParams}
                />

                <div className="topbar__content">
                    <div className="topbar__left">
                        {/*<SearchBar />*/}
                    </div>
                    <div className="topbar__right">

                        <NotificationsMenu
                            {...notificationParams}
                        />
                    </div>
                </div>
            </div>
        )
    }


}

export default TopBar;

